import React from 'react';
import PropTypes from 'prop-types';
import { components } from '@glowforge/ui-common';

const { Button, Markdown } = components;

const ActionButtons = ({ getHelpMarkdownSource, nextStepOnClick, nextStepStr }) => (
  <div className='actionButtons'>
    <Markdown source={getHelpMarkdownSource} />
    <Button className='btn clearLink' onClick={nextStepOnClick}>
      {nextStepStr}
    </Button>
  </div>
);

ActionButtons.propTypes = {
  getHelpMarkdownSource: PropTypes.string.isRequired,
  nextStepOnClick: PropTypes.func.isRequired,
  nextStepStr: PropTypes.string.isRequired,
};

export default ActionButtons;



// WEBPACK FOOTER //
// ./app/components/setup/action-buttons.jsx